import { render, staticRenderFns } from "./PayableAmount.vue?vue&type=template&id=64b33da7"
import script from "./PayableAmount.vue?vue&type=script&lang=js"
export * from "./PayableAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports